import { Component, Input } from '@angular/core';
import { AbstractControl, Validators } from '@angular/forms';
import { CustomValidator } from 'src/shared/validation';

@Component({
  selector: 'app-label',
  templateUrl: './app-label.component.html',
  styleUrls: ['./app-label.component.scss']
})
export class AppLabelComponent {

  @Input() class: string;
  @Input() for: string;
  @Input() htmlStr: string;
  @Input() control: AbstractControl;

  requiredSuffix = ' *';

  get required(): boolean {
    return this.control.hasValidator(Validators.required) ||
      this.control.hasValidator(CustomValidator.requiredLookupValue);
  }
}
